import { TableCell } from '@mui/material';
import { Status } from '@shared/ui/parts';
import { formatDateTime } from '@utils/date-helpers';

export default function StatusCreatedAtCell({ row, type }) {
  return (
    <TableCell>
      <div>
        <Status data={row} type={type} />
        <p className="secondary-text">{formatDateTime(row.created_at)}</p>
      </div>
    </TableCell>
  );
}
